<div class="grid-container margin-top">
  <report-command [dateRequired]="false" [fromDate]="fromDate" [toDate]="toDate" [runText]="'Search Queue'" [noDateSelected]="false" [noDateLabel]="'Search Without Date'" (reportGenerated)="runReport($event)" (reportDownloaded)="downloadReport()"></report-command>
  <div class="grid-x grid-margin-x">
    @for (opt of selectionOptions; track opt) {
      <div class="cell small-3 medium-3 large-3 text-align-center">
        <input type="radio" [id]="opt.id" [value]="opt.id" [(ngModel)]="queryOption" /> {{opt.text}}
      </div>
    }
    <div class="cell large-12 medium-12 small-12">
      <ag-grid-angular class="data-grid " [gridOptions]="gridOptions" [rowData]="data" [excelStyles]="excelStyles" aria-label="Onbase Queue Status"></ag-grid-angular>
    </div>
    <div class="cell large-12 medium-12 small-12 text-align-center margin-top">
      <span class="minor-margin-right">
        <button class="button" (click)="requeueAll()" [disabled]="documentsNeedingRequeue.length === 0">Requeue All</button>
      </span>
      <span class="minor-margin-left">
        <button class="button" (click)="regenerateInvoicesReceipts()" [disabled]="disableRegenerate">Regenerate Invoices &amp; Receipts</button>
      </span>
    </div>
  </div>
</div>
<a style="display:none" href="" target="_blank" #downloadLink rel="noopener noreferrer"></a>